export default __webpack_public_path__ + "static/breadcrumbs-icons-do-dark-bcd3597cd4924eab682f29c790bf07b4.png";